import React from 'react';
import styled from 'styled-components';

import useCountryConfig from 'common/hooks/useCountryConfig';
import { CountryConfigContextProvider } from 'modules/country/CountryConfigContext';
import { useExperienceModuleContext } from 'modules/experience-core';
import { useTelemetryExperienceEntityMetadata } from 'modules/experience-core/hooks/useTelemetryExperienceEntityMetadata';
import { ExperienceNps } from 'modules/nps/features/ExperienceNps';

import { Content } from '../components/layout/Content';
import { Sidebar } from '../components/layout/Sidebar';

const IndexPageContainer = styled.div`
  display: flex;
  height: 100vh;
`;

export const IndexPage = () => {
  useTelemetryExperienceEntityMetadata();

  const { country } = useExperienceModuleContext();
  const { countryConfig } = useCountryConfig(country);
  return (
    <CountryConfigContextProvider value={countryConfig ?? null}>
      <IndexPageContainer>
        <ExperienceNps />
        <Sidebar />
        <Content />
      </IndexPageContainer>
    </CountryConfigContextProvider>
  );
};
